<template lang="pug">
    el-row.cart__item
        el-col(:span='6' v-for="img in item.g_img").cart__item__img
            img(:src='img.g_img')            
        el-col(:span='18')
            h3.cart__item__name.cart__item__info {{item.g_name}}
            <div class="cart__item__name cart__item__info" v-if="hasDetail">({{item.gDt.gDt_desc}})</div>
            .cart__item__nums.cart__item__info
              <el-input-number :value='item.addCartNum' v-model="num" @change="handleChange" :min="1" :max="item.gDt.gDt_Maxnum"></el-input-number>
            .cart__item__price.cart__item__info $ {{item.g_price || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'}}  
            i.el-icon-delete.cart__item__delete(@click="removeFromCart(item.g_id)")
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'

import moment from 'moment'

export default {
  name: 'CartInfoItem',
  data() {
    return {
      hasDetail: true,
      num: 1,
      currentTime: '',
      price: '',
    }
  },
  props: ['item'],
  computed: {
    ...mapGetters('goods', ['getMaxNums']),
    ...mapState('cart', ['cart']),
    maxNums () {      
      return this.item.gDt.gDt_Maxnum
      // return this.getMaxNums(this.item.shop_id, this.item.g_id)
    }
  },
  created(){
    // alert('b')
    this.num = this.item.addCartNum
    this.getNowFormatDate()
    this.nowPrice()
    console.log('this.item', this.item)
  },
  methods: {
    ...mapMutations('cart', ['updateNums', 'removeFromCart']),
    handleChange (value) {
      // console.log(value)
      const updateInfo = { id: this.item.g_id, nums: value }
      // console.log('updateNums', this.updateNums(updateInfo))
      this.updateNums(updateInfo)
    },
    getNowFormatDate(){
      var date = new Date();
      var sign1 = "-";
      var sign2 = ":";
      var year = date.getFullYear() // 年
      var month = date.getMonth() + 1; // 月
      var day  = date.getDate(); // 日
      var hour = date.getHours(); // 时
      var minutes = date.getMinutes(); // 分
      var seconds = date.getSeconds() //秒
      // var weekArr = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天'];
      // var week = weekArr[date.getDay()];
      // 给一位数数据前面加 “0”
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (day >= 0 && day <= 9) {
        day = "0" + day;
      }
      if (hour >= 0 && hour <= 9) {
        hour = "0" + hour;
      }
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      // var currentdate = year + sign1 + month + sign1 + day + " " + hour + sign2 + minutes + sign2 + seconds + " " + week;
      var currentdate = year + sign1 + month + sign1 + day + " " + hour + sign2 + minutes + sign2 + seconds
      // console.log('currentdate', currentdate)
      this.currentTime =  currentdate
    },
    nowPrice(){
      if(this.item.g_onsale_etime){
        if(moment(this.item.g_onsale_etime) <= moment(this.currentTime)){          
          this.item.g_price = this.item.g_originPrice
          setTimeout(() => {
            this.$notify({
                title: '以下商品優惠已結束',
                message: this.item.g_name + '('+ this.item.gDt.gDt_desc +')',
                dangerouslyUseHTMLString: true,
                offset: 30,
                duration: 2000
            }) 
          }, 30);             
        }else{
          this.item.g_price = this.item.g_price
        }    
      }else{
        this.item.g_price = this.item.g_price
      }      
    }
  }
}
</script>

<style lang="scss" scoped>
.cart {
  &__item {
    padding: 2vw;
    border: 1px solid #f1f2f1;
    position: relative;
    &__info {
      height: 6vh;
      line-height: 6vh;
      padding-left: 5vw;
    }
    &__name {
      white-space: nowrap;
      overflow: scroll;
      height: 6vh;
      line-height: 6vh;
      margin: 0;
    }
    &__img {
      height: 18vh;
      display: flex;
      align-items: center;
      img {
        width: 100%;
        max-height: 18vh;
      }
    }
    &__price {
      color: #ee4d2d;
    }
    &__delete {
      position: absolute;
      font-size: 5vw;
      right: 0;
      bottom: 0;
      width: 10vw;
      height: 10vw;
      line-height: 10vw;
      text-align: center;
    }
  }
}
</style>
